module.exports = __webpack_public_path__ + "media/images/logos/logo-us-white-a49022294624acddf4c8b1d7d3955756.svg";